export default __webpack_public_path__ + "static/media/uvies-blue.01e903d5.svg";